import { Injectable } from '@angular/core';
import { AnalyticsEventProvider } from './analytics-event-provider.service';
import { ErrorEvent } from '../events/error-event';
import { HttpErrorResponse } from '@angular/common/http';
import { captureHandledError } from '@ichoosr-core/logging';

export interface ErrorEventArgs {
  element?: HTMLInputElement;
  error?: unknown;
  error_action?: string;
  field_name?: string;
}

@Injectable({
  providedIn: 'root',
})
export class AnalyticsErrorEventProvider extends AnalyticsEventProvider<ErrorEvent> {
  createAndPush(args: ErrorEventArgs): void {
    if (args.error !== undefined) {
      captureHandledError(args.error, { action: args.error_action, fieldName: args.field_name });
    }

    this.push(
      new ErrorEvent({
        error_action: args.error_action,
        field_name: args.field_name,
        error_type: this.getErrorType(args.error),
      }),
    );
  }

  getErrorType(error: unknown): string {
    if (error instanceof HttpErrorResponse) {
      switch (error.status) {
        case 400:
          return 'BadRequest';
        case 401:
          return 'Unauthorized';
        case 403:
          return 'Forbidden';
        case 404:
          return 'NotFound';
        case 500:
          return 'InternalServerError';
        default:
          return 'HttpError';
      }
    }

    return 'Unknown';
  }
}
